<template>
    <q-banner
        v-if="showBanner"
        class="background-yellow border-yellow q-mb-md q-mr-sm"
        rounded
        inline-actions
    >
        <template v-slot:avatar>
            <q-icon name="fa-solid fa-triangle-exclamation" color="warning" />
        </template>
        <span>
            {{
                $t(
                    "Sensor tracking is currently disabled for this planned downtime. Product counting will not automatically resume until the downtime period ends or the 'UNLOCK' button is pressed."
                )
            }}
        </span>
        <template v-slot:action>
            <q-btn
                flat
                id="confirm-shutdown-button"
                @click="unlock"
                :label="$t('Unlock')"
                color="warning"
            />
        </template>
    </q-banner>
</template>
<script>
export default {
    name: 'UnlockChangeoverBanner',
    emits: ['close', 'unlocked'],
    props: {
        show: {
            type: Boolean,
            default: false
        },
        assetId: {
            type: String,
            required: true
        }
    },
    data() {
        return {
            changeover: false
        };
    },
    computed: {
        /**
         * Determines whether the banner should be shown.
         *
         * @returns {boolean} - Returns true if the banner should be shown, otherwise false.
         */
        showBanner() {
            return this.show;
        }
    },
    methods: {
        /**
         * Closes the dialog and emits a 'close' event to notify parent components.
         */
        closeDialog() {
            this.showBanner = false;
            this.$emit('close');
        },
        /**
         * Unlocks the changeover for the current asset.
         */
        async unlock() {
            try {
                let response = await this.$axios.post(
                    `/assets/${this.assetId}/unlock_changeover/`
                );
                if (response.status === 200) {
                    this.$emit('unlocked');
                    this.$notifySuccess(
                        this.$t('Product counting resumed successfully')
                    );
                }
            } catch (error) {
                console.error('Failed to unlock due to: ', error);
                this.$notifyError(
                    this.$t('Failed to unlock. Please try again')
                );
            }
        }
    }
};
</script>
